import React from 'react';

const AutocompleteEntry = ({
                               entry,
                               clickAction,
                               submitAction,
                               inputValue,
                               query,
                               product,
                               lastEntry,
                           }) => {
    const handleInteraction = (e) => {
        if (e.key && e.key === 'ArrowUp') {
            e.target.previousElementSibling
                ? e.target.previousElementSibling.focus()
                : e.target.parentElement.parentElement.firstElementChild.focus();
        }
        if (e.key && e.key === 'ArrowDown') {
            e.preventDefault(); // Verhindert das Scrollen der Seite
            e.target.nextElementSibling?.focus();
        }
        if (e.key && e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            const event = new Event('closeAutocomplete');
            document.dispatchEvent(event);
        }
        if (e.key && e.key !== 'Enter') return;
        const entryText = product ? entry.name : entry.title;
        if (query !== entryText) {
            e.stopPropagation();
            clickAction(entryText);
            submitAction(entryText);
        }
    };

    const highlightQuery = (text, q) => {
        if (!q) return text;

        const regex = new RegExp(`(${q})`, 'gi');

        return text.split(regex).map((part, index) => (part.toLowerCase() === q.toLowerCase() ? (
            <span key={index} className="highlight">{part}</span>
        ) : (
            part
        )));
    };

    return (
        <React.Fragment>
            <li
                className={`cmp-search__autocomplete-entry${product && lastEntry ? ' last-product-entry' : ''}`}
                tabIndex={0}
                role={'option'}
                onClick={handleInteraction}
                onKeyDown={handleInteraction}>
                { !product && <span className="magenta-icon-search"></span>}
                { !product && <span className={'cmp-search__autocomplete-entry__title'}>{
                    highlightQuery(entry.title, inputValue)}</span>
                }
                { product && entry.image && <img src={entry.image} alt={entry.name}/>}
                { product && <span className={'cmp-search__autocomplete-entry__title'}>{
                    highlightQuery(entry.name, inputValue)}</span>
                }
            </li>
        </React.Fragment>
    );
};

export default AutocompleteEntry;
